// medias or media preview
export const getMediaByOfferId = (state) => (offerItemId) => state.medias[offerItemId]?.filter(
  (media) => [
    'WAITING_POST_QC',
    'WAITING_PRE_QC',
    'WAITING_EDITION',
    'WAITING_VALIDATION',
    'UPLOADED',
    'ASIDE',
    'REFUSED',
    'VALIDATED',
  ].includes(media?.attributes?.current_status)
  || media.preview,
);

// media
export const getMedias = (state) => () => state.medias;

// media
export const getMediaList = (state) => () => {
  if (!state.medias) {
    return null;
  }
  const OfferIds = Object.keys(state.medias);
  return OfferIds.reduce((acc, currentValue) => {
    acc.push(...state.medias[currentValue]);
    return acc;
  }, []);
};

// get last version of media file
export const getLastFile = (state) => (offerItemId, mediaId) => {
  const medias = state.medias[offerItemId];
  const media = medias.find(({ id }) => id === mediaId);
  const mediaFiles = [...media?.relationships?.files?.data]?.sort(
    (a, b) => b.attributes.version - a.attributes.version,
);
  return mediaFiles[0];
};
// get Video Media
export const getVideoMedia = (state) => (offerItemId, mediaId) => {
  const medias = state.medias[offerItemId];
  if (!medias?.length) return null;
  const lastFile = getLastFile(state)(offerItemId, mediaId);
  return lastFile?.attributes?.mime_type?.includes('video') ? lastFile : null;
};
// get media File
export const getMediaFile = (state) => (offerItemId, mediaId) => {
  const medias = state.medias[offerItemId];
  if (!medias?.length) return null;
  const lastFile = getLastFile(state)(offerItemId, mediaId);
  return lastFile?.attributes?.thumb;
};
// get media Name
export const getMediaName = (state) => (offerItemId, mediaId) => {
  const medias = state.medias[offerItemId];
  if (!medias?.length) return null;
  const lastFile = getLastFile(state)(offerItemId, mediaId);
  return lastFile?.attributes?.original_filename;
};

// get media Size
export const getMediaSize = (state) => (offerItemId, mediaId) => {
  const medias = state.medias[offerItemId];
  if (!medias?.length) return null;
  const lastFile = getLastFile(state)(offerItemId, mediaId);
  return lastFile?.attributes?.size;
};
// get media mime type
export const getMediaMimeType = (state) => (offerItemId, mediaId) => {
  const medias = state.medias[offerItemId];
  if (!medias?.length) return null;
  const lastFile = getLastFile(state)(offerItemId, mediaId);
  return lastFile?.attributes?.mime_type;
};

// get media MenuItem
export const getMediaMenuItem = (state) => (offerItemId, mediaId) => {
  const medias = state.medias[offerItemId];
  if (!medias?.length) return null;
  const media = medias.find(({ id }) => id === mediaId);

  const mediaMetaMenuItem = media?.relationships?.metas?.data
  .find(
    ({ attributes }) => attributes?.origin === 'Manual',
  );
  return mediaMetaMenuItem
    ? {
      id: mediaMetaMenuItem.id,
      name: mediaMetaMenuItem.attributes.value,
    }
    : null;
};

// get media Meta Name
export const getMediaMetaName = (state) => (offerItemId, mediaId) => {
  const medias = state.medias[offerItemId];
  if (!medias?.length) return null;
  const media = medias.find(({ id }) => id === mediaId);
  return media?.relationships?.metas?.data.find(
    ({ attributes }) => attributes.key === 'name',
  ) || null;
};

export const getMediaMetaTagged = (state) => {
  let renamedMedia = 0;
  const products = Object.keys(state.medias);
  products.forEach((product) => {
    state.medias[product].forEach((media) => {
      const mediaMeta = media.relationships?.metas?.data?.filter(({ attributes }) => attributes?.origin === 'Manual');
      if (mediaMeta?.length > 0) {
        renamedMedia += 1;
      }
    });
  });
  return renamedMedia;
};

export const getMediaCustomTags = (state) => state.mediaList?.filter((media) => media?.relationships?.metas?.data
  ?.find(({ attributes }) => attributes?.origin === 'Manual'));

export const getLabelSuggestions = (state) => state.suggestions;
